import { CommonLayoutComponent } from "./features/layouts/common-layout.component";
import { BoxStyleComponent } from "./pages/box-style/box-style.component";
import { BoxOptionsComponent } from "./pages/box-options/box-options.component";
import { Routes } from "@angular/router";
import { environment } from "../environments/environment";
import { requireCustomerLogin } from "./guards/require-login.guard";

export const routes: Routes = [
  {
    path: "",
    component: CommonLayoutComponent,
    children: [
      {
        path: "login",
        children: [
          {
            path: "",
            loadComponent: () => import("./pages/login/login.component").then((m) => m.LoginComponent),
          },
          {
            path: "checkout/:checkoutId",
            loadComponent: () => import("./pages/login/login.component").then((m) => m.LoginComponent),
          },
        ],
      },
      {
        path: "",
        pathMatch: "full",
        redirectTo: "start",
      },
      {
        path: "start",
        loadComponent: () => import("./pages/start/start.component").then((m) => m.StartComponent),
      },
      {
        path: "box-category",
        loadComponent: () => import("./pages/box-category/box-category.component").then((m) => m.CategoryComponent),
      },
      {
        path: "box-style",
        children: [
          {
            path: ":category/:uploadDesign",
            component: BoxStyleComponent,
            data: {
              title: "Box Style",
            },
          },
          {
            path: ":category",
            component: BoxStyleComponent,
            data: {
              title: "Box Style",
            },
          },
        ],
      },
      {
        path: "box-options",
        children: [
          {
            path: ":category/:subcategory",
            component: BoxOptionsComponent,
            data: {
              title: "Box Options",
            },
          },
          {
            path: ":category/:subcategory/:uploadDesign",
            component: BoxOptionsComponent,
            data: {
              title: "Box Options",
            },
          },
        ],
      },
      {
        path: "samples",
        loadComponent: () => import("./pages/samples/samples.component").then((m) => m.SamplesComponent),
      },
      {
        path: "upload-design",
        children: [
          {
            path: "",
            loadComponent: () =>
              import("./pages/upload-design/upload-design.component").then((m) => m.UploadDesignComponent),
            data: {
              title: "Upload Design",
            },
          },
          {
            path: ":category/:subcategory",
            loadComponent: () =>
              import("./pages/upload-design/upload-design.component").then((m) => m.UploadDesignComponent),
            data: {
              title: "Upload Design",
            },
          },
        ],
      },
      {
        path: "design",
        children: [
          {
            path: ":category/:subcategory",
            loadComponent: () => import("./pages/design/design.component").then((m) => m.DesignComponent),
          },
          {
            path: "",
            loadComponent: () => import("./pages/design/design.component").then((m) => m.DesignComponent),
          },
        ],
      },
      {
        path: "cart",
        loadChildren: () => import("./pages/cart/cart.routes").then((m) => m.CART_ROUTES),
      },
      {
        path: "cart/takeout-1",
        loadChildren: () => import("./pages/cart/cart.routes").then((m) => m.CART_ROUTES),
      },
      {
        path: "cart/takeout-2",
        loadChildren: () => import("./pages/cart/cart.routes").then((m) => m.CART_ROUTES),
      },
      {
        path: "contact-us",
        loadComponent: () => import("./pages/contact-us/contact-us.component").then((m) => m.ContactUsComponent),
      },
      {
        path: "continue-project",
        canActivate: [requireCustomerLogin],
        loadComponent: () =>
          import("./pages/continue-project/continue-project.component").then((m) => m.ContinueProjectComponent),
      },
      {
        path: "review-box",
        loadComponent: () => import("./pages/review-box/review-box.component").then((m) => m.ReviewBoxComponent),
      },
      {
        path: "designer",
        loadComponent: () => import("./features/remote/designer.component").then((m) => m.DesignerComponent),
      },
      {
        path: "designer/:target/:projectId",
        loadComponent: () => import("./features/remote/designer.component").then((m) => m.DesignerComponent),
      },
      {
        path: "account",
        canActivate: [requireCustomerLogin],
        children: [
          {
            path: "",
            loadComponent: () => import("./pages/account/account.component").then((m) => m.AccountComponent),
            data: {
              title: "Account Page",
            },
          },
          {
            path: "update-account",
            loadComponent: () =>
              import("./pages/account/update-account/update-account.component").then((m) => m.UpdateAccountComponent),
            data: {
              title: "Update Account",
            },
          },
          {
            path: "update-password",
            loadComponent: () =>
              import("./pages/account/update-password/update-password.component").then(
                (m) => m.UpdatePasswordComponent
              ),
            data: {
              title: "Update Password",
            },
          },
        ],
      },
      ...(environment.features?.rewards
        ? [
            {
              path: "rewards",
              canActivate: [requireCustomerLogin],
              loadComponent: () => import("./pages/rewards/rewards.component").then((m) => m.RewardsComponent),
            },
          ]
        : []),
      {
        path: "order-history",
        canActivate: [requireCustomerLogin],
        loadComponent: () =>
          import("./pages/account/order-history/order-history.component").then((m) => m.OrderHistoryComponent),
        data: {
          title: "Order History",
        },
      },
      {
        path: "design-services",
        loadComponent: () =>
          import("./pages/design-services/design-services.component").then((m) => m.DesignServicesComponent),
      },
      {
        path: "account/login",
        loadComponent: () => import("./pages/logpage/logpage.component").then((m) => m.LogPageComponent),
      },
      {
        path: "account/register",
        loadComponent: () => import("./pages/signup/signup.component").then((m) => m.SignupComponent),
      },
    ],
  },
];
